<template>
	<div class="usePowerUnitBody custom-scrollbar">
		<!-- 上部预览 -->
		<DetailOverView class="marginTop upWindow"></DetailOverView>
		<!-- 下部预览（设备） -->
		<DevOverView class="marginTop downWindow"></DevOverView>
	</div>
</template>

<script>
	import DetailOverView from '@/page/projectDingZhi/ningbo/WorkorderDetailOverView.vue'
	import DevOverView from '@/page/projectDingZhi/ningbo/WorkorderDetailDevOverView.vue'
	export default {
		components: {
			DetailOverView,
			DevOverView,
		},
		props: [],
		data() {
			return {}
		},
		created() {
		},
		mounted() {
		},
		destroyed() {},
		computed: {
		},
		watch: {},
		methods: {
		}
	}
</script>

<style scoped>
	.usePowerUnitBody {
		display: flex;
		flex-wrap: wrap;
		padding: 1%;
		overflow: auto;
	}
	
	.marginTop {
		margin-top: 8px;
	}
	
	.upWindow {
		width: 100%;
		height: 300px;
	}

	.downWindow {
		width: 100%;
		height: 350px;
	}
	
</style>
